import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, withStyles } from "@material-ui/core";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    boxSizing: "border-box",
    padding: "24px 16px",
    // Soft teal-tinted canvas so refresh doesn’t flash pure white against the rest of the app
    backgroundColor: "#f0f7f8",
    borderTop: "4px solid #089bab",
  },
  progress: {
    color: "#089bab",
  },
  label: {
    marginTop: 20,
    fontSize: "14px",
    fontFamily: "'Poppins'",
    lineHeight: 1.5,
    color: "#37474f",
    textAlign: "center",
    maxWidth: 320,
  },
};

function SessionBootstrapScreen({ classes, message }) {
  return (
    <div className={classes.root} role="status" aria-live="polite" aria-busy="true">
      <CircularProgress className={classes.progress} size={40} />
      <p className={classes.label}>{message}</p>
    </div>
  );
}

SessionBootstrapScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
};

SessionBootstrapScreen.defaultProps = {
  message: "Verifying your session…",
};

export default withStyles(styles)(SessionBootstrapScreen);
